import {
  Accordion,
  AccordionBody,
  AccordionHeader,
} from "@material-tailwind/react";
import React, { useEffect, useState, useLayoutEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";
import NavbarHome from "../components/ui/NavbarHome";
import "./Home/Home.css";
import Footer from "../components/ui/Footer";
import { BackButton } from "../components/ui/Swicons";

export default function Faqs() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    setOpen(1);
  }, []);
  const handleOpen = (value) => {
    setOpen(open === value ? 0 : value);
  };
  return (
    <>
      <NavbarHome />
      <br />
      <div className="mt-24">
        <span className="font-nunito">
          <div className="relative">
            <div className="lg:min-h-full relative flex items-center lg:px-32 justify-center ">
              <div className="max-w-8xl bg-white p-12 shadow-lg rounded-xl border-2 space-y-8 sm:mx-0 mx-6">
                <div>
                  <button
                    onClick={() => navigate(-1)}
                    className="hidden lg:block"
                  >
                    <BackButton />
                  </button>
                  <h3 className="text-center text-3xl font-extrabold text-gray-900">
                    FAQ's
                  </h3>
                </div>
                <div>
                  <h1 className="text-2xl font-bold mb-4 mt-20 text-center">
                    About ScopeX
                  </h1>
                  <Accordion open={open === 1} onClick={() => handleOpen(1)}>
                    <AccordionHeader>What is ScopeX?</AccordionHeader>
                    <AccordionBody className="text-lg">
                      <p>
                        ScopeX is a modern money transfer platform that
                        leverages the power of blockchain technology. Unlike
                        traditional financial systems, we use cutting-edge
                        blockchain technology to provide a faster, more
                        transparent, and secure money transfer experience.
                      </p>
                    </AccordionBody>
                  </Accordion>

                  <Accordion open={open === 2} onClick={() => handleOpen(2)}>
                    <AccordionHeader>
                      Where does ScopeX operate?
                    </AccordionHeader>
                    <AccordionBody className="text-lg">
                      <p>
                        Currently, ScopeX offers its services within the
                        Eurozone and India. However, we have plans to expand our
                        reach to other countries in the near future.
                      </p>
                    </AccordionBody>
                  </Accordion>

                  <h1 className="text-2xl font-bold text-center my-12">
                    Using ScopeX
                  </h1>

                  <Accordion open={open === 3} onClick={() => handleOpen(3)}>
                    <AccordionHeader>
                      How long does a transfer take with ScopeX?
                    </AccordionHeader>
                    <AccordionBody className="text-lg">
                      <p>
                        ScopeX stands out for its efficiency. Once we receive
                        the funds, transactions are typically processed within a
                        matter of minutes. Our commitment is to ensure that your
                        money reaches its destination promptly, without any
                        undue delays.
                      </p>
                    </AccordionBody>
                  </Accordion>

                  <Accordion open={open === 4} onClick={() => handleOpen(4)}>
                    <AccordionHeader>
                      How much money can be transferred at once with ScopeX?{" "}
                    </AccordionHeader>
                    <AccordionBody className="text-lg">
                      At ScopeX, we aim to provide flexibility while adhering to
                      regulatory standards. Users can comfortably transfer up to
                      €25,000 annually at no additional cost.
                    </AccordionBody>
                  </Accordion>

                  <Accordion open={open === 5} onClick={() => handleOpen(5)}>
                    <AccordionHeader>
                      How does ScopeX ensure the security of my transfers?
                    </AccordionHeader>
                    <AccordionBody className="text-lg">
                      ScopeX prioritizes the security of your transactions. Our
                      platform uses advanced encryption methods, and our
                      blockchain-based system offers transparency, ensuring that
                      your money reaches its intended destination without any
                      hitches.
                    </AccordionBody>
                  </Accordion>

                  <Accordion open={open === 6} onClick={() => handleOpen(6)}>
                    <AccordionHeader>
                      How do I track my ScopeX transfer?
                    </AccordionHeader>
                    <AccordionBody className="text-lg h-4">
                      Stay in the loop with real-time updates. After initiating
                      a transfer, you can monitor its progress directly from
                      your ScopeX account dashboard.
                    </AccordionBody>
                  </Accordion>

                  <h1 className="text-2xl font-bold text-center my-12">
                    Safety and Security
                  </h1>

                  <Accordion open={open === 7} onClick={() => handleOpen(7)}>
                    <AccordionHeader>How safe is ScopeX?</AccordionHeader>
                    <AccordionBody className="text-lg">
                      Your security is our utmost priority. ScopeX employs
                      advanced blockchain technology, which is renowned for its
                      encryption capabilities and transparency. This ensures
                      that every transaction is not only secure but also
                      traceable, providing an added layer of confidence.
                    </AccordionBody>
                  </Accordion>
                  <Accordion open={open === 8} onClick={() => handleOpen(8)}>
                    <AccordionHeader>
                      How do I stay away from fraudsters?
                    </AccordionHeader>
                    <AccordionBody className="text-lg">
                      Awareness is the first line of defense. Always ensure that
                      you're transacting through the official ScopeX platform.
                      We recommend never sharing OTPs or passwords, using strong
                      unique passwords, regularly monitoring your transaction
                      history, and contacting our support team for any
                      suspicious activity.
                    </AccordionBody>
                  </Accordion>

                  <Accordion open={open === 9} onClick={() => handleOpen(9)}>
                    <AccordionHeader>
                      Is ScopeX affiliated with any bank?
                    </AccordionHeader>
                    <AccordionBody className="text-lg">
                      While ScopeX operates as an independent platform, we have
                      established collaborations with various financial entities
                      to ensure smooth and efficient transactions.
                    </AccordionBody>
                  </Accordion>

                  <h1 className="text-2xl font-bold text-center my-12">
                    General Information
                  </h1>
                  <Accordion open={open === 10} onClick={() => handleOpen(10)}>
                    <AccordionHeader>What is remittance?</AccordionHeader>
                    <AccordionBody className="text-lg">
                      Remittance is the act of sending money, often across
                      borders, to support various needs like family care,
                      education, or investments. It's a practice that has been
                      around for centuries, helping bridge economic gaps and
                      support global families.
                    </AccordionBody>
                  </Accordion>
                  <Accordion open={open === 11} onClick={() => handleOpen(11)}>
                    <AccordionHeader>
                      How does remittance impact economies?{" "}
                    </AccordionHeader>
                    <AccordionBody className="text-lg">
                      Remittances can play a pivotal role in a country's
                      economy. For many nations, especially where a significant
                      number of residents work abroad, these funds sent home can
                      be a substantial source of income, sometimes even
                      surpassing foreign aid.
                    </AccordionBody>
                  </Accordion>
                  <Accordion open={open === 12} onClick={() => handleOpen(12)}>
                    <AccordionHeader>
                      Who participates in a remittance transaction?
                    </AccordionHeader>
                    <AccordionBody className="text-lg">
                      A remittance journey typically involves the Sender, who
                      initiates the transfer, the Receiver, who benefits from
                      it, and intermediaries, which can range from digital
                      platforms like ScopeX to traditional banks.
                    </AccordionBody>
                  </Accordion>

                  <h1 className="text-2xl font-bold text-center my-12">
                    Account Management
                  </h1>

                  <Accordion open={open === 13} onClick={() => handleOpen(13)}>
                    <AccordionHeader>
                      How do I delete my ScopeX account?
                    </AccordionHeader>
                    <AccordionBody className="text-lg">
                      To delete your ScopeX account, simply contact our support
                      team. They'll guide you through a secure account closure
                      process, ensuring your data's privacy.
                    </AccordionBody>
                  </Accordion>
                  <Accordion open={open === 14} onClick={() => handleOpen(14)}>
                    <AccordionHeader>
                      Do I get a receipt for my transactions?
                    </AccordionHeader>
                    <AccordionBody className="text-lg">
                      Yes, every transaction is followed by a receipt sent to
                      your registered email. You can also download all receipts
                      from your ScopeX dashboard.
                    </AccordionBody>
                  </Accordion>
                  <Accordion open={open === 15} onClick={() => handleOpen(15)}>
                    <AccordionHeader>
                      What documents are required for verification?
                    </AccordionHeader>
                    <AccordionBody className="text-lg">
                      For verification, we require either a valid passport or a
                      national ID. This ensures the authenticity of our users
                      and the security of our platform.
                    </AccordionBody>
                  </Accordion>
                </div>
              </div>
            </div>
          </div>
        </span>
      </div>
      <br />
      <ScrollToTop smooth color="#5c6e64" />
      <Footer />
    </>
  );
}
